export default "__VITE_ASSET__Bu2o2OAO__"